import PropTypes from 'prop-types';
import cls from 'classnames'

import { getContent, isDDEnv, isWHEnv } from '@/utils/helper';

import Ingredient from '@/molecules/Ingredient/Ingredient';
import { SectionHeaderComponent } from '@/molecules/SectionHeader/SectionHeader';

import { CtfSectionHeaderType } from '@/utils/constants';

export default function IngredientSection({ fields, entries }) {
  const ingredientLength = fields?.ingredients?.length;
  return (
    <div
      className={cls(
        'aaco__ingredient-section',
        'flex flex-col',
        'dd-en:rounded-r-[8px] dd-kr:rounded-r-[8px]',
        'ml-0 pr-[30px] dd-kr:mx-8 dd-en:mx-8 mb-[93px] dd-en:mb-12 dd-kr:mb-12 md:mb-[110px] dd-en:md:mb-20 dd-kr:md:mb-20',
        'px-0 md:pl-[30px] dd-en:px-8 dd-kr:px-8 dd-en:pl-0 dd-kr:pl-0 dd-en:pr-[60px] dd-kr:pr-[60px] dd-en:md:pr-[49px] dd-kr:md:pr-[49px] pt-[53px] pb-[60px] md:py-20 dd-kr:py-20 dd-en:py-20 dd-kr:md:py-[90px] dd-en:md:py-[90px]',
        'bg-warmer-grey dd-en:bg-progressive-blue dd-kr:bg-progressive-blue', {
          "!m-0 !pb-1 !pt-0 !px-0": isWHEnv(),
        }
      )}
      id="ingredients"
    >
      <div className="aaco__ingredient-section__header container mx-auto dd-en:hidden dd-kr:hidden">
        <SectionHeaderComponent
          headingWeight="h2"
          title={fields.title}
          titleColor="text-acacia"
          type={CtfSectionHeaderType.SECTION}
        />
      </div>
      <div className="aaco__ingredient-section__header hidden dd-en:block dd-kr:block">
        <SectionHeaderComponent
          headingWeight="h3"
          sectionHeadingSize="h3"
          title={fields.title}
          titleColor="text-white"
          titleStyle="uppercase"
          type={CtfSectionHeaderType.SECTION}
        />
      </div>
      {ingredientLength > 0 && (
        <div className={cls(
          'aaco__ingredient-section__content__items',
          'container hidden dd-kr:grid dd-en:grid grid-rows md:grid-cols-4 gap-[54px] dd-en:gap-10 dd-kr:gap-10 md:gap-5',
          'md:mx-auto pt-11 md:pt-10 dd-en:pt-[30px] dd-kr:pt-[30px] dd-en:md:pt-0 dd-kr:md:pt-0'
        )}>
          {fields.ingredients.map((i, idx) => {
            const { content, title, hideHeader } =
              getContent(i?.sys?.id, entries)?.fields ?? {};
            return (
              <Ingredient
                entries={entries}
                hideHeader={hideHeader}
                contents={content?.content}
                key={`${title}-${idx}`}
                title={title}
              />
            );
          })}
        </div>
      )}
      {ingredientLength > 0 && (
        <div className="dd-kr:hidden dd-en:hidden flex flex-col md:flex-row container mx-auto pt-10">
          {ingredientLength > 1 && <div className="flex-auto md:flex-1"></div>}
          <div className={cls(
              'aaco__ingredient-section__content__items',
              'grid grid-rows md:grid-cols-2 flex-auto md:flex-[2_2_0%] gap-10 md:gap-x-14 md:gap-y-4',
            )}>

            {fields.ingredients.map((i, idx) => {
              const { content, title, hideHeader } =
                getContent(i?.sys?.id, entries)?.fields ?? {};

              return (
                <Ingredient
                  entries={entries}
                  hideHeader={hideHeader}
                  contents={content?.content}
                  key={`${title}-${idx}`}
                  num={idx}
                  length={ingredientLength}
                  title={title}
                />
              );
            })}
          </div>
        </div>
      )}
      <Ingredient />
    </div>
  );
}

IngredientSection.defaultProps = {
  ingredients: [],
  title: '',
};

IngredientSection.propTypes = {
  fields: PropTypes.shape({
    ingredients: PropTypes.array,
    title: PropTypes.string,
  }),
};
